/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { IconCheck, IconChevronDown } from '@tabler/icons-react'
import clsx from 'clsx'
import { useState } from 'react'

import { Container } from 'src/components/Container/Container'

import styles from './Accordion.module.scss'

import type { AccordionModule } from 'src/types/Module'

export const Accordion = ({ contents, style }: AccordionModule) => {
  const [selected, setSelected] = useState<number | null>(null)

  return (
    <Container className={styles[style]}>
      {contents.map((acc, index) => (
        <div key={acc.title}>
          <div
            className={clsx(styles.accHeader, selected === index && styles.opened)}
            onClick={() => setSelected(index === selected ? null : index)}
          >
            {style === 'checkmark' && <IconCheck className={styles.check} stroke={1.6} />}
            {acc.title}
            {style === 'faq' && <IconChevronDown stroke={1.6} className={styles.chevron} />}
          </div>
          <div
            className={clsx(styles.accContent, selected === index && styles.visible)}
            dangerouslySetInnerHTML={{ __html: acc.content }}
            suppressHydrationWarning
          />
        </div>
      ))}
    </Container>
  )
}
